"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbCCSession = exports.EntrypointType = void 0;
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const events_1 = require("../../../security/events");
__exportStar(require("./storage"), exports);
var types_1 = require("./types");
Object.defineProperty(exports, "EntrypointType", { enumerable: true, get: function () { return types_1.EntrypointType; } });
class MbCCSession extends web_ui_security_1.BaseSession {
    constructor(sessionStorage) {
        super(sessionStorage);
        this.xhr = null;
        this.usd = null;
    }
    setXHR(newXhr) {
        this.xhr = newXhr;
    }
    setUSD(newUsd) {
        this.usd = newUsd;
    }
    onRefreshToken(callback) {
        return (0, events_1.subscribeRefreshedSessionEvent)(callback);
    }
    onRefreshTokenError(callback) {
        return (0, events_1.subscribeErrorRefreshingSessionEvent)(callback);
    }
    onRefreshingToken(callback) {
        return (0, events_1.subscribeRefreshingSessionEvent)(callback);
    }
}
exports.MbCCSession = MbCCSession;
//# sourceMappingURL=index.js.map